module.exports = __webpack_public_path__ + "static/logo_blue-19efcd13f7afa02be0231c5d27a4d056.png";